import { environment } from './../../environments/environment';
const domain = environment.apiDomain + '/api/';

export const Doctypes = {
  user_permission: 'User Permission',
  hospitality_unit: 'Hospitality Unit', //"Company"
  roles: 'Role',
  users: 'User',
  roles_permission: 'Roles Permission',
  business_unit: 'Business Unit',
  module_def: 'Module Def',
  WfRoles: 'WF Roles',
  ezy_employee: 'Ezy Employee',
  marsha_code: 'Marsha Code',
  role_module_management: 'Role Module Management',
  suite_items: 'Suite items',
  departments: 'Ezy Departments',
  app_info: 'App Info',
  Social_Login_Key: 'Social Login Key',
  New_Social_Login_Key: 'New Social Login Key',
  ezy_file_extensions:'Ezy File Extensions'
};

export const ApiUrls = {
  resource: domain + `resource`,
  login: domain + 'method/login',
  logout: domain + 'method/logout',
  uploadFile: domain + `method/upload_file`,
  get_companies_list:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.companies_list`,
  create_company:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.create_company_in_suite_settings`,
  modules_list:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.modules_enabled_by_companies`,
  get_list:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.converting_resource_to_custom`,
  get_by_name:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.get_doc_custom`,
  getting_auth_url: domain + `method/ezy_flow.utils.getting_auth_url`,
  post_resource:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.converting_resource_post_call_to_custom_post_call`,
  put_resource:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.edit_call_resource_doctype`,
  reset_password:
    domain +
    `method/ezy_flow.pwd_management.doctype.routes.routes.reset_initial_password`,
  initial_password:
    domain + `method/ezy_flow.pwd_management.doctype.routes.routes.update_pwd`,
  admin_setting_password:
    domain +
    `method/ezy_flow.pwd_management.doctype.routes.routes.create_users_password_if_user_is_created_in_ezy_emp`,
  check_old_password:
    domain +
    `method/ezy_flow.pwd_management.doctype.routes.routes.change_old_password`,
  users_by_marsha:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.users_list_by_marsha`,
  update_child_table_of_doctype:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.update_child_table_of_doctype`,
  modules_based_on_company:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.modules_based_on_company`,

  //Child Doctype APi Calls..

  put_resource_child_doc:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.update_child_table_of_doctype`,

  post_child_table_of_doctype:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.post_child_table_of_doctype`,
  converting_custom_api_delete_call:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.converting_custom_api_delete_call`,
  getUserPermissionsList:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.user_permissions`,
  check_record_exists:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.check_record_exists`,
  get_module_list:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.get_module_list`,
  import_ezy_employee_list:
    domain +
    `method/ezy_flow.ezy_flow.doctype.ezy_employee.ezy_employee.enqueuing_data_import`,
    login_with_username_and_email:
    domain +
    `method/ezy_flow.ezy_flow.doctype.ezy_employee.ezy_employee.login_with_user_and_email`,
};
